import { React, useEffect, useRef, useState, } from 'react';
import { Row, Col, Button, Space, message, Form, Tag, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, } from 'react-router-dom'
import { default as ProTableOT } from "../../../../utility/ProTable_ot";
// import SystemHolidayModal from './SystemHolidayModal';
import { PlusOutlined } from "@ant-design/icons";
import { useClass } from '../../Class/controller/ClassController';
import { usePunchManagementController } from '../controller/usePunchManagementController';
import { useCourseRecordController } from '../controller/useCourseRecordController'
// import { useBillPaymentClass } from '../..//controller/BillPaymentClassController';
import { useBillPaymentClass } from '../../Tuition/controller/BillPaymentClassController';

// import { useSystemHoliday } from '../controller/useSystemHolidayController';


const ClassTimeSetting = () => {
    const navigate = useNavigate();
    const actionRef = useRef()
    const ref = useRef(0);
    const [extra_columns, set_extra_columns] = useState([]);
    const [loading, set_loading] = useState(0);
    const [pageSize, setPageSize] = useState(20)
    const [columns, setColumns] = useState([
        {
            title: '日期',
            key: 'date',
            dataIndex: 'date',
            align: 'center',
            sorter: false,
        },
        {
            title: '星期',
            key: 'week',
            dataIndex: 'date',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                let week = dayjs(text, 'YYYY-MM-DD').day()
                let weekArr = ["日", "一", "二", "三", "四", "五", "六"]
                return weekArr[week]
            }
        },
        {
            title: '繳費單',
            key: 'bill_payment_grade_class_data',
            dataIndex: 'bill_payment_grade_class_data',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return (<Space>
                    {
                        text.map((value) => {
                            return <Tag color='cyan'>
                                {value?.year}年第{value?.year_serial}期
                            </Tag>
                        })
                    }
                </Space>)
            }
        },
        {
            title: '日程',
            key: 'schedule',
            dataIndex: 'schedule',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return text
            }
        },
        {
            title: '上課老師',
            key: 'teacher_data',
            dataIndex: 'teacher_data',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return <Space>
                    {
                        (text || []).map((value) => {
                            return <Tag color='gold'>
                                {value?.teacher_name}
                            </Tag>
                        })
                    }
                </Space>
            }
        },

    ]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [searchData, setSearchData] = useState({
        grade_class_id: null,
        only_date: [dayjs().startOf('month'), dayjs().endOf('month')],
        class_id: null,
        bill_payment_grade_class_id: null
    })
    const reload = () => {
        actionRef.current.reloadAndRest();
    }

    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const getBillPaymentGradeClassOption = (BillPaymentClassData) => {
        let options = []
        BillPaymentClassData.forEach((element) => {
            let grade_class_data = element?.grade_class_data || []
            let grade_class_data_first = grade_class_data.find((ele) => true)
            let bill_payment_grade_class_datas = grade_class_data_first?.bill_payment_grade_class_data
            bill_payment_grade_class_datas.forEach((bill_payment_grade_class_data) => {
                options.push({
                    label: `${bill_payment_grade_class_data?.year}年 第${bill_payment_grade_class_data?.year_serial}期`,
                    value: bill_payment_grade_class_data?.bill_payment_grade_class_id,
                })
            })

        })
        return options
    }
    const uploadFile = (e) => {
        console.log({
            files: e.target.files
        })
        const files = e.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('grade_class_id', searchData?.grade_class_id);

        postCourseRecordExcel(form_data)
    }
    const {
        classOption,
        getClassOption,
    } = useClass({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        getCourseRecordData,
        getCourseRecordExcel,
        postCourseRecordExcel
    } = useCourseRecordController({
        onBefore: () => { },
        onFinish: ({
            axiosMode,status
        }) => {
            if(axiosMode ==='postCourseRecordExcel'){
                if(status === "success"){
                    message.success('匯入成功')
                }
                else{
                    message.error('匯入失敗')
                }
                reload()
            }
        }
    })
    const {
        BillPaymentClassData,
        getBillPaymentClassData,
    } = useBillPaymentClass({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        if (classOption.length > 0) {
            let first_data = classOption.find((element) => true)
            let grade_class_data = first_data?.grade_class_data || []
            let grade_class_data_first = grade_class_data.find((ele) => true)
            let grade_class_id = grade_class_data_first?.grade_class_id
            setSearchData((pre) => {
                return {
                    ...pre,
                    grade_class_id: `${grade_class_id}`,
                    class_id: first_data?.class_id
                }
            })
        }
    }, [classOption])
    useEffect(() => {
        checkAll()
        getClassOption()
    }, []);

    useEffect(() => {
        actionRef.current.reload()
    }, [searchData])
    useEffect(() => {
        getBillPaymentClassData({
            class_id: searchData?.class_id
        })
    }, [searchData.class_id])

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
            </Col>
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <Row gutter={[8, 16]} justify={"end"}>
                            <Col>
                                <Space
                                >
                                    <div>
                                        班級：
                                    </div>
                                    <Select
                                        allowClear={false}
                                        placeholder={"選擇班級"}
                                        popupMatchSelectWidth={false}
                                        options={classOption.map((val) => {
                                            let grade_class_data = val?.grade_class_data || []
                                            let grade_class_data_first = grade_class_data.find((ele) => true)
                                            let grade_class_id = grade_class_data_first?.grade_class_id
                                            return {
                                                label: `${val?.name} ${val?.name_serial}`,
                                                value: `${grade_class_id}`
                                            }
                                        })}
                                        value={searchData?.grade_class_id}
                                        onChange={(val) => {
                                            let selectClass = classOption.find((element) => {
                                                let grade_class_data = element?.grade_class_data || []
                                                let grade_class_data_first = grade_class_data.find((ele) => true)
                                                let grade_class_id = grade_class_data_first?.grade_class_id
                                                console.log({
                                                    grade_class_id,
                                                    val
                                                })
                                                return `${grade_class_id}` === val
                                            })

                                            setSearchData((pre) => {
                                                return {
                                                    ...pre,
                                                    grade_class_id: val,
                                                    class_id: selectClass?.class_id
                                                }
                                            })
                                        }}
                                    >
                                    </Select>
                                </Space>
                            </Col>
                            {/* <Col>
                                <Space
                                >
                                    <div>
                                        繳費單：
                                    </div>
                                    <Select
                                        placeholder={"選擇繳費單"}
                                        popupMatchSelectWidth={false}
                                        options={
                                            getBillPaymentGradeClassOption(BillPaymentClassData || [])
                                        }
                                        value={searchData?.bill_payment_grade_class_id}
                                        onChange={(val) => {

                                            setSearchData((pre) => {
                                                return {
                                                    ...pre,
                                                    bill_payment_grade_class_id:val
                                                }
                                            })
                                        }}
                                    >
                                    </Select>
                                </Space>
                            </Col> */}
                            <Col>
                                <Space
                                >
                                    <div>
                                        上課日期：
                                    </div>
                                    <DatePicker.RangePicker
                                        allowClear={false}
                                        format={"YYYY-MM-DD"}
                                        value={searchData?.only_date}
                                        onChange={(val) => {
                                            setSearchData((pre) => {
                                                return {
                                                    ...pre,
                                                    only_date: val ?? []
                                                }
                                            })
                                        }}
                                    />

                                </Space>

                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 16]} justify={"end"}>
                            <Col>
                                <Button
                                    style={{ background: '#56b673',color: '#FFFFFF' }}
                                    onClick={() => {
                                        getCourseRecordExcel()
                                    }}
                                >
                                    匯出範本
                                </Button>
                            </Col>
                            <Col>
                                <Space >
                                    <Button
                                        style={{ backgroundColor: '#41A084', color: '#FFFFFF' }}
                                        onClick={(e) => ref.current.click()} block>
                                        檔案上傳
                                    </Button>
                                    <input
                                        type="file"
                                        id="my_file" hidden ref={ref}
                                        onChange={(e) => {
                                            uploadFile(e)
                                        }}
                                    />
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <ProTableOT
                            options={
                                {
                                    search: false
                                }
                            }
                            cardBordered={false}
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'holiday_setting_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() => [

                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                let only_date_start = null
                                let only_date_end = null
                                let only_date = searchData?.only_date || []

                                if (only_date.length > 0) {
                                    only_date_start = dayjs(only_date[0]).format("YYYY-MM-DD")
                                    only_date_end = dayjs(only_date[1]).format("YYYY-MM-DD")
                                }

                                let newParams = {
                                    // bill_payment_grade_class_id:searchData?.bill_payment_grade_class_id,
                                    grade_class_id: searchData?.grade_class_id,
                                    date_start: only_date_start,
                                    date_end: only_date_end
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };

                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)

                                return getCourseRecordData(newParams)
                            }}
                            pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            rowSelection={false}
                        />
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
export default ClassTimeSetting;